import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function VocabLab() {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Visiting the catalog is open to everyone, but opening an exercise
  // requires being signed in.
  const openExercise = (path: string) => {
    if (!user) {
      navigate("/auth");
      return;
    }
    navigate(path);
  };
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12">
        <div className="mx-auto max-w-3xl text-center">
          <h1 className="font-poppins text-4xl md:text-5xl font-bold text-foreground mb-3">Vocabulary Lab</h1>
          <p className="text-muted-foreground mb-10">Sharpen your vocabulary with today's spelling exercises.</p>
        </div>

        <div className="mx-auto grid max-w-3xl gap-6 sm:grid-cols-2">
          <button
            type="button"
            onClick={() => openExercise("/vocab-lab/word-drill")}
            className="group flex w-full cursor-pointer flex-col items-center justify-center rounded-2xl border border-border bg-card p-8 shadow-sm transition-all hover:shadow-xl hover:-translate-y-1"
          >
            <div className="mb-4 grid grid-cols-5 gap-1">
              {["W","O","R","D","S"].map((c, i) => (
                <div
                  key={i}
                  className={`flex h-9 w-9 items-center justify-center text-sm font-bold uppercase text-white border-2 ${
                    i === 0 ? "bg-[hsl(var(--wordle-correct))] border-[hsl(var(--wordle-correct))]" :
                    i === 2 ? "bg-[hsl(var(--wordle-present))] border-[hsl(var(--wordle-present))]" :
                    "bg-[hsl(var(--wordle-absent))] border-[hsl(var(--wordle-absent))]"
                  }`}
                >
                  {c}
                </div>
              ))}
            </div>
            <h2 className="text-2xl font-bold text-card-foreground">Word Drill</h2>
            <p className="mt-2 text-sm text-muted-foreground text-center">Daily 5-letter spelling exercise.</p>
          </button>

          <button
            type="button"
            onClick={() => openExercise("/vocab-lab/group-sort")}
            className="group flex w-full cursor-pointer flex-col items-center justify-center rounded-2xl border border-border bg-card p-8 shadow-sm transition-all hover:shadow-xl hover:-translate-y-1"
          >
            <div className="mb-4 grid grid-cols-2 gap-1.5">
              <div className="h-9 w-12 rounded bg-[hsl(var(--connections-yellow))]" />
              <div className="h-9 w-12 rounded bg-[hsl(var(--connections-green))]" />
              <div className="h-9 w-12 rounded bg-[hsl(var(--connections-blue))]" />
              <div className="h-9 w-12 rounded bg-[hsl(var(--connections-purple))]" />
            </div>
            <h2 className="text-2xl font-bold text-card-foreground">Group Sort</h2>
            <p className="mt-2 text-sm text-muted-foreground text-center">Sort 16 terms into 4 themed sets.</p>
          </button>

          <button
            type="button"
            onClick={() => openExercise("/vocab-lab/quick-recall")}
            className="group flex w-full cursor-pointer flex-col items-center justify-center rounded-2xl border border-border bg-card p-8 shadow-sm transition-all hover:shadow-xl hover:-translate-y-1 sm:col-span-2"
          >
            <div className="mb-4 flex h-9 items-center gap-2 text-3xl">⚡</div>
            <h2 className="text-2xl font-bold text-card-foreground">Quick Recall</h2>
            <p className="mt-2 text-sm text-muted-foreground text-center">Live academic quiz practice — buzz in with friends.</p>
          </button>
        </div>
      </div>
    </div>
  );
}